<template>
  <div class="start">
    <div class="start__intro">
      <Intro
        heading="Beställ e-faktura"
        description="Uppge vilken bank du har."
      />
    </div>
    <div class="start__form">
      <Form />
    </div>
  </div>
</template>

<script>
import Form from './components/Form'
import Intro from '@/templates/components/Intro'

export default {
  name: 'Start',
  components: {
    Form,
    Intro
  },
  data () {
    return {
      msg: 'Start'
    }
  },
  computed: {
    user: function () {
      return window.user
    }
  },
  created: function () {
    console.log('START, user loaded', this.user)

    if (this.$store.state.progress.completed) {
      console.log('Start, redirect to thanks due to progress done')
      this.$router.push({ name: 'Thanks' })
    } else if (!this.$route.query.id || !this.user.id) {
      console.log('Start, redirect to helpdesk due to missing id')
      this.$router.push({ name: 'Helpdesk' })
    } else {
      const user = {
        id: this.user.id,
        name: this.user.name,
        ssn: this.user.ssn,
        customerId: this.user.customerId,
        submissionType: this.user.submissionType
      }

      this.$store.commit('user/reset')
      this.$store.commit('user/saveUser', user)
    }
  },
  mounted: function () {
    window.scrollTo(0, 0)
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/views/Start/index.vue